import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FINANCIAL_SNAPSHOT_API } from './financial-snapshot-api.token';
import { MockFinancialSnapshotApiService } from './mock/mock-financial-snapshot-api.service';

/**
 * Registers the Financial Snapshot API seam.
 * Defaults to the stateful mock until DEP-1 + OQ-1 (live Http is a follow-up story).
 */
export function provideFinancialSnapshot(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MockFinancialSnapshotApiService,
    {
      provide: FINANCIAL_SNAPSHOT_API,
      useExisting: MockFinancialSnapshotApiService,
    },
  ]);
}
